import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e3e2e7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Software wordt geheel naar wens van de opdrachtgever ontwikkeld. In samenwerking met de opdrachtgever wordt gekeken naar de meest efficiënte oplossing voor een vraagstuk. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Software wordt compatibel en veilig gemaakt door systemen, technieken en hulpmiddelen te updaten. Eventueel wordt ook functionaliteit naar wens toegevoegd. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/contact" }, "contact", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_layout = _resolveComponent("header-layout")!
  const _component_page_button = _resolveComponent("page-button")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_notice_alert = _resolveComponent("notice-alert")!
  const _component_single_block = _resolveComponent("single-block")!
  const _component_footer_layout = _resolveComponent("footer-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_layout, {
      title: "Werkzaamheden",
      displaySearchForm: false
    }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_page_button, {
              title: "Ontwikkeling",
              path: "/werkzaamheden/ontwikkeling"
            }),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_page_button, {
              title: "Onderhoud",
              path: "/werkzaamheden/onderhoud"
            }),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_single_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_notice_alert, null, {
              default: _withCtx(() => [
                _createTextVNode(" MaatOntwikkeling levert ook websites, applicaties, domeinnamen, e-mailadressen en nog veel meer. Bij twijfel over een werkzaamheid, neemt u "),
                _hoisted_4,
                _createTextVNode(" op met MaatOntwikkeling. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_footer_layout)
  ], 64))
}